import { Link } from 'react-router-dom';
import { mangaList, categories } from '@/mocks/manga';
import MangaCard from '@/components/base/MangaCard';
import SectionTitle from '@/components/base/SectionTitle';

export default function HomePage() {
  const hotManga = mangaList.filter(m => m.isHot).slice(0, 8);
  const newManga = mangaList.filter(m => m.isNew).slice(0, 8);
  const recentManga = [...mangaList].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 8);

  return (
    <main>
      {/* SEO Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "韩漫之家",
        "url": "https://www.hanmanzhijia.com",
        "description": "韩漫之家作为资源门户，通过简单网址即可实现韩漫在线观看并获取免费韩漫大全，内容丰富且访问便捷。",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://www.hanmanzhijia.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "韩漫之家",
        "url": "https://www.hanmanzhijia.com",
        "description": "韩漫在线观看资源门户，提供免费韩漫大全",
        "sameAs": ["https://weibo.com/hanmanzhijia"]
      }) }} />

      {/* Hero Section */}
      <section className="relative h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20art%20style%20collage%20of%20various%20manga%20characters%20in%20dynamic%20poses%2C%20warm%20vibrant%20colors%2C%20comic%20book%20aesthetic%2C%20digital%20illustration%20with%20soft%20glow%20effects%2C%20dramatic%20composition%20with%20negative%20space%20for%20text%2C%20clean%20modern%20manhwa%20style&width=1920&height=1080&seq=hero-bg-hanman&orientation=landscape"
          alt="韩漫之家 - 韩漫在线观看"
          title="韩漫之家 - 免费韩漫大全"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/60"></div>
        <div className="relative z-10 w-full text-center px-4 md:px-6">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            韩漫之家
          </h1>
          <p className="text-base md:text-xl text-background-50/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            最全的<strong>韩漫在线观看</strong>平台，汇聚海量<strong>免费韩漫大全</strong>资源。<br className="hidden md:block" />
            简单网址即可畅享精彩漫画世界，每日更新，精彩不断。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/category/hot" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold rounded-full hover:bg-primary-600 transition-colors text-base whitespace-nowrap cursor-pointer">
              热门推荐 <i className="ri-fire-line ml-1"></i>
            </Link>
            <Link to="/category/new" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 font-semibold rounded-full border border-background-50/30 hover:bg-background-50/30 transition-colors text-base whitespace-nowrap cursor-pointer">
              最新上架 <i className="ri-rocket-line ml-1"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Category Quick Nav */}
      <section className="py-8 bg-background-50 border-b border-background-200/70">
        <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
          <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
                className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-100 text-sm font-medium text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Hot Manga */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
          <SectionTitle title="热门推荐" subtitle="万人追更的精品韩漫" href="/category/hot" />
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
            {hotManga.map((manga) => (
              <MangaCard key={manga.id} manga={manga} />
            ))}
          </div>
        </div>
      </section>

      {/* Latest Updates */}
      <section className="py-10 md:py-14 bg-background-100">
        <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
          <SectionTitle title="最近更新" subtitle="每日新鲜内容，精彩不容错过" />
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
            {recentManga.map((manga) => (
              <MangaCard key={manga.id} manga={manga} />
            ))}
          </div>
        </div>
      </section>

      {/* Feature Banner */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
          <div className="relative rounded-xl overflow-hidden h-[200px] md:h-[280px] flex items-center">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20panoramic%20illustration%20with%20bookshelves%20filled%20with%20comics%2C%20warm%20reading%20atmosphere%2C%20cozy%20library%20or%20cafe%20setting%2C%20soft%20golden%20lighting%2C%20inviting%20and%20comfortable%20mood%2C%20no%20text%20in%20image&width=1400&height=600&seq=banner-mid-01&orientation=landscape"
              alt="韩漫之家阅读体验"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/65 to-black/30"></div>
            <div className="relative z-10 px-6 md:px-10 w-full">
              <h2 className="text-xl md:text-3xl font-bold text-background-50 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                每日更新 · 品质保证
              </h2>
              <p className="text-sm md:text-base text-background-50/85 max-w-lg mb-4">
                韩漫之家精选全网优质韩漫资源，确保每一部作品都经过精心筛选和翻译，让您享受最佳的阅读体验。
              </p>
              <Link to="/category/new" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} className="inline-flex items-center gap-1 px-6 py-2.5 bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                探索新作 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* New Arrivals */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
          <SectionTitle title="最新上架" subtitle="刚刚上线的精彩新作" href="/category/new" />
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
            {newManga.map((manga) => (
              <MangaCard key={manga.id} manga={manga} />
            ))}
          </div>
        </div>
      </section>

      {/* Stats / CTA */}
      <section className="py-12 md:py-16 bg-accent-500">
        <div className="mx-auto px-4 md:px-6 max-w-[1280px] text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 dark:text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            海量韩漫，尽在韩漫之家
          </h2>
          <p className="text-base text-background-50/90 dark:text-foreground-950/80 mb-8 max-w-xl mx-auto">
            超过 <strong className="text-background-50 dark:text-foreground-950">1000+</strong> 部优质韩漫作品，每日持续更新，满足您的阅读需求。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="text-center px-6">
              <div className="text-3xl md:text-4xl font-bold text-background-50 dark:text-foreground-950">1000+</div>
              <div className="text-sm text-background-50/80 dark:text-foreground-950/70 mt-1">漫画作品</div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-background-50/30"></div>
            <div className="text-center px-6">
              <div className="text-3xl md:text-4xl font-bold text-background-50 dark:text-foreground-950">50万+</div>
              <div className="text-sm text-background-50/80 dark:text-foreground-950/70 mt-1">每日读者</div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-background-50/30"></div>
            <div className="text-center px-6">
              <div className="text-3xl md:text-4xl font-bold text-background-50 dark:text-foreground-950">每日更新</div>
              <div className="text-sm text-background-50/80 dark:text-foreground-950/70 mt-1">持续连载</div>
            </div>
          </div>
        </div>
      </section>

      {/* Category Sections */}
      {['romance', 'fantasy', 'action'].map((catSlug) => {
        const catManga = mangaList.filter(m => m.category === catSlug).slice(0, 4);
        const catInfo = categories.find(c => c.slug === catSlug);
        if (!catInfo || catManga.length === 0) return null;
        return (
          <section key={catSlug} className="py-10 md:py-14 bg-background-50">
            <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
              <SectionTitle title={`${catInfo.name}漫画`} subtitle={`精选${catInfo.name}类韩漫`} href={`/category/${catSlug}`} />
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
                {catManga.map((manga) => (
                  <MangaCard key={manga.id} manga={manga} />
                ))}
              </div>
            </div>
          </section>
        );
      })}

      {/* FAQ Section */}
      <section className="py-10 md:py-14 bg-background-100">
        <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>常见问题</h2>
            <p className="text-sm text-foreground-500 mt-2">关于韩漫之家的常见疑问解答</p>
          </div>
          <div className="max-w-3xl mx-auto space-y-3">
            {[
              { q: '韩漫之家有哪些类型的漫画？', a: '韩漫之家涵盖恋爱、奇幻、动作、悬疑、搞笑、剧情、古风、惊悚等多种类型的韩漫作品，满足不同读者的口味需求。' },
              { q: '韩漫之家的漫画多久更新一次？', a: '我们每日都会更新漫画内容，热门连载作品保持与韩国同步更新的节奏，确保读者能够第一时间看到最新内容。' },
              { q: '韩漫之家的漫画是免费的吗？', a: '韩漫之家提供大量免费韩漫资源，读者可以通过简单网址直接免费浏览海量韩漫内容，无需付费订阅。' },
              { q: '如何找到我想看的漫画？', a: '您可以通过首页的分类导航、搜索功能或热门推荐列表快速找到感兴趣的漫画作品。我们也提供按更新时间和评分排序的浏览方式。' },
            ].map((faq, idx) => (
              <details key={idx} className="group bg-background-50 rounded-lg border border-background-200/70">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer font-medium text-foreground-900 text-sm">
                  {faq.q}
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              { "@type": "Question", "name": "韩漫之家有哪些类型的漫画？", "acceptedAnswer": { "@type": "Answer", "text": "韩漫之家涵盖恋爱、奇幻、动作、悬疑、搞笑、剧情、古风、惊悚等多种类型的韩漫作品，满足不同读者的口味需求。" } },
              { "@type": "Question", "name": "韩漫之家的漫画多久更新一次？", "acceptedAnswer": { "@type": "Answer", "text": "我们每日都会更新漫画内容，热门连载作品保持与韩国同步更新的节奏，确保读者能够第一时间看到最新内容。" } },
              { "@type": "Question", "name": "韩漫之家的漫画是免费的吗？", "acceptedAnswer": { "@type": "Answer", "text": "韩漫之家提供大量免费韩漫资源，读者可以通过简单网址直接免费浏览海量韩漫内容，无需付费订阅。" } },
              { "@type": "Question", "name": "如何找到我想看的漫画？", "acceptedAnswer": { "@type": "Answer", "text": "您可以通过首页的分类导航、搜索功能或热门推荐列表快速找到感兴趣的漫画作品。我们也提供按更新时间和评分排序的浏览方式。" } },
            ]
          }) }} />
        </div>
      </section>
    </main>
  );
}